export default "__VITE_ASSET__BCWLSjiv__"